export enum SearchState {
  Idle = 'idle',
  Stalled = 'stalled',
  Loading = 'loading',
}
